module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "loading text-muted"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col activeShipmentsTable"
  }, [_vm._m(0), _vm._v(" "), _c('active-shipments-row', {
    attrs: {
      "name": "standard",
      "data": _vm.data.standard
    }
  }), _vm._v(" "), _c('active-shipments-row', {
    attrs: {
      "name": "overnight",
      "data": _vm.data.overnight
    }
  }), _vm._v(" "), _c('active-shipments-row', {
    attrs: {
      "name": "expedited",
      "icon": "expeditedOne",
      "data": _vm.data.expedited
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header",
    staticStyle: {
      "height": "50px"
    }
  }, [_c('div', {
    staticClass: "col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Late")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("At Risk")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("On Time")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 upcoming"
  }, [_c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Upcoming")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f139eea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/ActiveShipmentsWidget.vue
// module id = 751
// module chunks = 0